import { languages, locale } from 'src/config/language.config';
export const getAllowedLocaleFromLanguage = (language) => {
    if (language) {
        const formattedLanguage = language.toLowerCase();
        if (locale?.fr?.toLowerCase().includes(formattedLanguage) ||
            formattedLanguage.includes(languages?.fr?.toLowerCase())) {
            return locale.fr;
        }
    }
    return locale.en;
};
